/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import img_def from "../../Recursos/img_cat_defecto.png";
import Marcas_Home from "../Componentes/Home/Marcas_Home";
import Preguntas_Home from "../Componentes/Home/Preguntas_Home";
import Puntos_Home from "../Componentes/Home/Puntos_Home";
import Creamos_Home from "../Componentes/Home/Creamos_Home";
import Footer from "../Footer";
import Detalle_Producto from "../Componentes/Detalle_Producto";
import {useParams} from "react-router-dom";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {contexData} from "../../App";
import Tarjeta_Ultimos_Detalle from "../Tarjetas/Tarjeta_Ultimos_Detalle";
import {obtenerObjLocal} from "../../Servicios/BDLocal/obtenerObjLocal";
import {guardarObjLocal} from "../../Servicios/BDLocal/guardarObjLocal";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Detalle = () => {
    const {masSM, sCell} = useResponsive()
    const cData = useContext(contexData)
    const parms = useParams()
    const [producto, setProducto] = useState({})
    const [productos, setProductos] = useState([])
    const [ultimos, setUltimos] = useState([])

    const guardarProductoLocal = (prod) => {


        let arr = []
        arr = obtenerObjLocal({key: 'ultimos'})


        if (arr) {

            let index = arr.findIndex((it) => it.id === prod.id)
            if (index === -1) {
                arr.push(prod)
                guardarObjLocal({key: 'ultimos', obj: arr})
            }

        } else {
            arr = []
            arr.push(prod)
            guardarObjLocal({key: 'ultimos', obj: arr})
        }

        let arrUltimos = []
        for (let i = 0; i < arr.length; i++) {

            if (arr[arr.length - 2 - i]) {
                arrUltimos.push(arr[arr.length - 2 - i])
                if (i > 2) {
                    i = arr.length
                }
            }


        }

        setUltimos(arrUltimos)


    }

    useEffect(() => {

        irArriba()

        if (parms && parms.id) {
            obtenerDoc('productos', parms.id).then((dox) => {
                if (dox.res && dox.data) {
                    setProducto(dox.data)
                    guardarProductoLocal(dox.data)
                }
            })
        }

    }, [parms]);


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 1 : 3}}
            >


                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 0.5}}
                        spacing={2}
                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}} sx={{mt: 3}}>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{pl: 1}}>
                                <Typography sx={{fontSize: 20, fontWeight: 600, color: '#4C4C4C'}}>
                    <span><img src={img_def} width={30}
                               height={'auto'}
                               style={{marginBottom: -6, marginRight: 6}}/></span>
                                    {`Detalle de: ${producto.nombre}`}</Typography>
                            </Grid>

                            {!sCell &&
                                <Grid container size={{xs: 12, sm: 12, md: 6}} justifyContent={'flex-end'}>
                                    <Typography sx={{fontSize: 18, fontWeight: 600, color: '#00000090'}}>Ultimos
                                        vistos</Typography>
                                </Grid>
                            }

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>


                                <Grid container size={{xs: 12, sm: 12, md: 8}}>
                                    <Detalle_Producto item={producto}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 4}}>
                                    {ultimos.map((it) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}>

                                            <Tarjeta_Ultimos_Detalle item={it}

                                            />

                                        </Grid>
                                    ))}
                                </Grid>


                            </Grid>


                        </Grid>


                    </Grid>


                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                    <Marcas_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Preguntas_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Puntos_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Creamos_Home/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                    <Footer/>
                </Grid>


            </Grid>


        </Grid>
    );

}
export default Seccion_Detalle